import { ICON_COMPONENT_MAP } from "../agentToolIcons";

export const TOOL_ICON_MAP = {
  web_search: ICON_COMPONENT_MAP.SearchIcon,
  http_request: ICON_COMPONENT_MAP.HttpIcon,
  extract_webpage: ICON_COMPONENT_MAP.LanguageIcon,
  send_email: ICON_COMPONENT_MAP.EmailOutlinedIcon,
  list_agents: ICON_COMPONENT_MAP.SmartToyOutlinedIcon,
  list_agent_sessions: ICON_COMPONENT_MAP.ForumOutlinedIcon,
  send_message: ICON_COMPONENT_MAP.ForumOutlinedIcon,
  get_self_config: ICON_COMPONENT_MAP.SettingsSuggestOutlinedIcon,
  update_self_config: ICON_COMPONENT_MAP.EditNoteOutlinedIcon,
  create_agent: ICON_COMPONENT_MAP.SmartToyOutlinedIcon,
  run_workflow: ICON_COMPONENT_MAP.AccountTreeOutlinedIcon,
  get_session: ICON_COMPONENT_MAP.HistoryOutlinedIcon,
  get_chat_session: ICON_COMPONENT_MAP.ForumOutlinedIcon,
  create_table: ICON_COMPONENT_MAP.TableChartOutlinedIcon,
  add_column: ICON_COMPONENT_MAP.ViewColumnOutlinedIcon,
  rename_column: ICON_COMPONENT_MAP.DriveFileRenameOutlineIcon,
  delete_column: ICON_COMPONENT_MAP.DeleteOutlineIcon,
  create_row: ICON_COMPONENT_MAP.PlaylistAddOutlinedIcon,
  update_row: ICON_COMPONENT_MAP.EditOutlinedIcon,
  query_table: ICON_COMPONENT_MAP.StorageOutlinedIcon,
  delete_row: ICON_COMPONENT_MAP.DeleteOutlineIcon,
  form_fields: ICON_COMPONENT_MAP.DynamicFormOutlinedIcon,
  get_form: ICON_COMPONENT_MAP.AssignmentOutlinedIcon,
  fill_form: ICON_COMPONENT_MAP.FactCheckOutlinedIcon,
  review_task: ICON_COMPONENT_MAP.RateReviewOutlinedIcon,
  plan_tasks: ICON_COMPONENT_MAP.ListAltOutlinedIcon,
  update_task_queue: ICON_COMPONENT_MAP.UpdateOutlinedIcon,
  run_code: ICON_COMPONENT_MAP.CodeOutlinedIcon,
  generate_document: ICON_COMPONENT_MAP.DescriptionOutlinedIcon,
  send_slack_component: ICON_COMPONENT_MAP.SendOutlinedIcon,
  schedule_message: ICON_COMPONENT_MAP.ScheduleSendOutlinedIcon,
  edit_scheduled_message: ICON_COMPONENT_MAP.EditCalendarOutlinedIcon,
  recurring_schedule: ICON_COMPONENT_MAP.EventRepeatOutlinedIcon,
  edit_recurring_schedule: ICON_COMPONENT_MAP.EditCalendarOutlinedIcon,
  create_calendar_event: ICON_COMPONENT_MAP.CalendarTodayOutlinedIcon,
  read_calendar_event: ICON_COMPONENT_MAP.EventNoteOutlinedIcon,
  edit_calendar_event: ICON_COMPONENT_MAP.EditCalendarIcon,
  move_ticket: ICON_COMPONENT_MAP.MoveDownOutlinedIcon,
  create_ticket: ICON_COMPONENT_MAP.AddCardOutlinedIcon,
  update_ticket: ICON_COMPONENT_MAP.EditOutlinedIcon,
  get_ticket: ICON_COMPONENT_MAP.AssignmentOutlinedIcon,
  add_ticket_comment: ICON_COMPONENT_MAP.ChatBubbleOutlineOutlinedIcon,
};
